export default __webpack_public_path__ + "static/media/afr_2.3818325a.png";